import React from 'react';
import { cn } from '../../lib/utils';

const STEP_LABELS = { admin: 'Admin', council: 'Council', residents: 'Residents' };
const SKIP_REASONS = { council: 'council item', conflict: 'conflict of interest' };

const STATUS_STYLES = {
  approved: 'border-success text-success',
  pending: 'border-primary text-primary font-medium',
  rejected: 'border-destructive text-destructive',
  returned: 'border-warning text-warning',
  skipped: 'border-border text-muted-foreground line-through',
  waiting: 'border-border text-muted-foreground'
};

const STATUS_PREFIX = { approved: '✓ ', rejected: '✕ ', returned: '↩ ' };

export function originLabel(origin) {
  if (!origin) return null;
  if (origin.kind === 'agent') return origin.name ? `${origin.name} agent` : 'Agent';
  if (origin.kind === 'council') return origin.name ? `Council · ${origin.name}` : 'Council';
  return origin.kind.charAt(0).toUpperCase() + origin.kind.slice(1);
}

// "From → Admin → Council" for an approval with steps (context/Approvals.md).
function StepTrail({ approval }) {
  if (!approval.steps) return null;
  const from = originLabel(approval.origin);
  return (
    <ol aria-label="Steps" className="flex flex-wrap items-center gap-1 text-xs">
      {from && (
        <li className="px-2 py-0.5 rounded-full border border-border text-muted-foreground">From: {from}</li>
      )}
      {approval.steps.map((step, i) => (
        <li key={i} className="flex items-center gap-1">
          <span aria-hidden="true" className="text-muted-foreground">→</span>
          <span className={cn('px-2 py-0.5 rounded-full border whitespace-nowrap', STATUS_STYLES[step.status] || STATUS_STYLES.waiting)}>
            {STATUS_PREFIX[step.status] || ''}{STEP_LABELS[step.kind] || step.kind}
            {step.status === 'skipped' && SKIP_REASONS[step.note] ? ` (${SKIP_REASONS[step.note]})` : ''}
          </span>
        </li>
      ))}
    </ol>
  );
}

export default StepTrail;
